import { useEffect, useState } from 'react';

const useScrollTracker = (scrolledTopY: number) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > scrolledTopY) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolledTopY]);

  return scrolled;
};

export default useScrollTracker;

export const useMainComponentScrollTracker = (ref: any) => {
  const [distanceFromTop, setDistanceFromTop] = useState(0);

  useEffect(() => {
    const calculateDistanceFromTop = () => {
      if (ref.current) {
        const distance = ref.current.getBoundingClientRect().top;
        setDistanceFromTop(distance);
      }
    };
    calculateDistanceFromTop();
  }, [distanceFromTop, ref]);

  return distanceFromTop;
};

export const useScrollHorizontTracker = (ref: any) => {
  const [isStartReached, setIsStartReached] = useState(true);
  const [isEndReached, setIsEndReached] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = ref.current;
      if (!scrollContainer) return;
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      const isEnd = scrollLeft + clientWidth >= scrollWidth;
      const isStart = scrollLeft === 0;
      setIsStartReached(isStart);
      setIsEndReached(isEnd);
    };
    const scrollContainer = ref.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [ref]);

  return { isStartReached, isEndReached };
};

export const useScrollVerticalTracker = (ref: any) => {
  const [isEnd, setIsEnd] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const container = ref.current;
      if (!container) return;
      const containerTop = container.offsetTop;
      const containerHeight = container.offsetHeight;
      const screenHeight = window.innerHeight;
      const { scrollY } = window;

      const contanerEndFromTop = containerTop + containerHeight - 72;

      const viewPortEndFromTop = scrollY + screenHeight;

      if (contanerEndFromTop <= viewPortEndFromTop) {
        setIsEnd(true);
      } else {
        setIsEnd(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return isEnd;
};
